export default __webpack_public_path__ + "static/media/readIcon.0938b2ad.svg";